export const tr = {
    "TRIGGER_LISTEN": "Tetikleyicileri dinliyorum",
    "ASSIST_EMPTY_MSG": "AI ajanı konuşmanızı dinliyor ve tetiklendiğinde otomatik olarak yardımcı olmaya hazır.",
    "MYBOT_TRIGGET_LISTEN": "Şu anda aktif bir My Bot görevi yok",
    "MYBOT_EMTPY_MSG": "My Bot'ta bir görev başlatmak için arama sekmesine gidin ve istediğiniz görev için \"Ajan girişleriyle çalıştır\" seçeneğini seçin.",
    "PROACTIVE_MODE": "Proaktif Mod",
    "SETTINGS": "Ayarlar",
    "HELP_AND_SUPPORT": "Yardım ve Destek",
    "HELP": "Yardım",
    "AUTO_SCROLL_TOOLTIP":"Asistan Sekmesi, Botum ve Transkript Sekmesi İçeriğinin otomatik kaydırmasını kontrol eder",
    "LANGUAGE": "Dil",
    "FILE_NAME":"Dosya adı",
    "THEME": "Tema",
    "AUTOMATIC": "Otomatik",
    "DARK": "Karanlık",
    "LIGHT": "Aydınlık",
    "THEME_DESC": "Bu, sistem varsayılan modunu kullanacaktır",
    "DOCUMENTATION": "Dokümantasyon",
    "DOC_DESC": "Detaylı dokümantasyon makalelerimizi inceleyin.",
    "FAQ_U": "SSS",
    "FAQ_DESC": "AI ajanıyla ilgili sıkça sorulan soruları kontrol edin.",
    "KORE_ACADEMY": "Kore Akademisi",
    "KORE_ACA_DESC": "Akademi kurslarına katılarak AI ajanı hakkında daha fazla bilgi edinin.",
    "SEARCH": "Ara",
    "MY_BOT": "My Bot",
    "ASSIST": "Yardım",
    "TAB_TEXT":"Hiçbir sekme etkin değil! Lütfen en az bir sekmeyi etkinleştirin",
    "TRANSCRIPT": "Transkript",
    "HISTORY": "Geçmiş",
    "STARTOVER": "Sıfırla",
    "TAP_SEARCH":"Aramak için dokunun",
    "RESTART_INPUTS": "Yakalanan girişlerle yeniden başlat",
    "ASKCUSTOMER": "Müşteriye Sor",
    "TELLCUSTOMER": "Müşteriye Söyle",
    "WELCOME_MSG": "Hoş Geldiniz Mesajı",
    "SEND": "Gönder",
    "SENT": "Gönderildi",
    "AWAITING": "Cevap Bekleniyor | Devam etmek için yazın",
    "OVERRIDE": "Devam etmek için yazın",
    "OVERRIDE_FILE": "Devam etmek için Dosya Ekleyin",
    "ACCEPT_RESPONSE": "Cevap Kabul Edildi",
    "AGENT_ENTERED": "Ajan Girdi",
    "EXPECTED_FORMAT": "Beklenen Format",
    "INPUT_VALUES": "Giriş Değerleri",
    "RESTART": "Yeniden Başlat",
    "START_OVER": "Sıfırla",
    "RESTART_CAPTURE": "Yakalanan girişlerle yeniden başlat",
    "CANCEL": "İptal",
    "INTERRUPT_DIALOG": "DİALOG GÖREVİ DURDURULDU",
    "RUN": "ÇALIŞTIR",
    "RUN_AGENT": "Ajanın girişiyle çalıştır",
    "STEP": "Adım",
    "DIALOG_TASK": "Diyalog Görevi",
    "FAQ": "SSS",
    "SNIPPET": "Cevaplar",
    "ARTICLE": "Web Sayfaları",
    "FILE": "Dosya",
    "SUGGESTED": "Önerilen",
    "ALL_DIALOG": "Tüm Diyalog Görevleri",
    "DIALOG_TEXT": "Diyalog",
    "INTENT_IDENTIFIED": "Müşteri ifadesi",
    "NOT_WHAT_LOOKING": "Yanlış Öneri?",
    "BOT": "Bot",
    "CUSTOMER": "Müşteri",
    "YOU": "Siz",
    "TERMINATE_CONV": "Diyalog Görevini Sonlandır",
    "TERMINATE_CONV_DESC": "Diyalog görevini sonlandırmak istediğinizden emin misiniz? AI ajanı artık önerilerde bulunamayacak.",
    "YES_TERMINATE": "Evet, Sonlandır",
    "NO_CANCEL": "Hayır, İptal Et",
    "OVERRIDE_CONTINUE": "Üzerine yazma moduyla devam et",
    "SUMMARY_TEXT": "Özet",
    "SUBMIT": "Gönder",
    "INTERRUPT_OCCURED": "Kesinti Gerçekleşti",
    "IDENTIFIED_INTENT": "Belirlenen niyet",
    "INTERRUPT_DESC": "Bunu çalıştırmak mevcut Diyalog Görevini sonlandıracaktır.",
    "ACCEPT_RUN": "Kabul Et ve Çalıştır",
    "RUN_LATER": "Sonra Çalıştır",
    "KNOW_MORE": "Daha Fazla Bilgi Edinin",
    "MORE_TEXT": "Daha Fazla",
    "LESS_TEXT": "Daha Az",
    "VIEW_MORE": "Daha Fazla Gör",
    "VIEW_LESS": "Daha Az Gör",
    "SHOW_MORE_FAQ": "Daha Fazla SSS Göster",
    "SHOW_LESS_FAQ": "Daha Az SSS Göster",
    "SHOW_MORE_ARTICLE": "Daha Fazla Web Sayfası Göster",
    "SHOW_LESS_ARTICLE": "Daha Az Web Sayfası Göster",
    "SHOW_MORE_SNIPPET": "Daha Fazla Cevap Göster",
    "SHOW_LESS_SNIPPET": "Daha Az Cevap Göster",
    "SHOW_MORE_FILES": "Daha Fazla Dosya Göster",
    "SHOW_LESS_FILES": "Daha Az Dosya Göster",
    "VIEW_ALL_DIALOG": "Tüm Diyalogları Gör",
    "VIEW_FEW_DIALOG": "Birkaç Diyaloğu Gör",
    "HELP_FULL": "Yardımcı Oldu mu?",
    "THANKYOU": "Teşekkürler!",
    "EXPAND_MORE": "Genişlet / Daha Fazla",
    "CLOSE_TEXT": "Kapat",
    "STARTED": "Başladı",
    "ENDED": "Bitti",
    "VIEW_FULL_ARTICLE": "Web sayfasını gör",
    "VIEW_FULL_FILE": "Dosyayı gör",
    "COPIED": "Kopyalandı",
    "SENTI_ANALY": "Duygu Analizi",
    "WRONG_SUGGESTION": "Yanlış Öneri",
    "INCORRECT_INTENT": "Yanlış niyet",
    "ACCIDENTAL_CLICK": "Kazara tıklama",
    "TIME_TAKING": "Zaman alıyor",
    "OTHER": "Diğer",
    "PLAYBOOK_EMPTY_MSG": "Oyun kitabını seçin",
    "PLAYBOOK_EMPTY_DESC": "AI ajanı, mevcut tüm oyun kitaplarının dinamik olmasından dolayı oyun kitabını yükleyemiyor. Oyun kitabına erişmek için 'Oyun Kitabını Seç' butonuna tıklayın",
    "STAGE": "Aşama",
    "PROCEED_TO_CLOSE": "Kapatmaya devam et",
    "RECOMENDED_PLAYBOOK": "ÖNERİLEN OYUN KİTABI",
    "PRIMARY_SCRIPTS": "ANA SENARYOLAR",
    "DYNAMIC_SCRIPTS": "DİNAMİK SENARYOLAR",
    "RESUME": "Devam Et",
    "ENABLE_CLOSE": "Kapatma aşamasını etkinleştirmek için kapatmaya devam et butonuna tıklayın",
    "LIST_VIEW": "Liste Görünümü",
    "TERMINATE": "Sonlandır",
    "MINIMIZE": "Küçült",
    "MAXIMIZE": "Büyüt",
    "NO_SEARCH_RESULT": "Hiçbir arama sonucu bulunamadı",
    "SENTIMENT_AWAITING": "Duygu analizi bekleniyor",
    "POSITIVE": "Pozitif",
    "NEGATIVE": "Negatif",
    "ASSOCIATED_WORK_NOTES": "Geçmiş Çözüm Notları",
    "AGENT_JOINED_CONV": "Ajan sohbete katıldı",
    "AUTOSCROLL_ASSIST": "Otomatik Kaydırma Yardım Sekmesi İçeriği",
    "FILE_SIZE_MSG": "Dosya boyutu 25MB'ı geçmemelidir. Lütfen tekrar deneyin.",
    "OVERRIDE_BTN": "Üzerine Yaz",
    "CHOOSE_FILE": "Dosya Seç",
    "SUMMARY_ERROR_TEXT": "Üzgünüz, ancak bu konuşma için özeti oluştururken bir sorun oluştu. Lütfen kendi özetinizi oluşturun.",
    "ASK_A_QUESTION": "Bir soru sor",
    "COPY": "Kopyala",
    "PLAYBOOK": "Oyun kitabı",
    "TELL_US_MORE": "Bize daha fazla anlatın…",
    "THANKS_FEEDBACK": "Geri bildiriminiz için teşekkürler",
    "SOMETHING_WRONG": "Bir şeyler yanlış gitti",
    "CLICK_ERROR_DETAILS": "Hata detaylarını görmek için tıklayın",
    "NO_ACTIVE_PLAYBOOK": "Aktif bir oyun kitabı yok",
    "REPHRASE_QUESTION": "Sorumunuzu yeniden ifade edebilir misiniz yoksa başka bir şey sorabilir misiniz?",
    "VIEW_FULL_ARTICLE_2": "Tam makaleyi görüntüle",
    "VIEW_FULL_FILE_2": "Tam dosyayı görüntüle",
    "INTERNAL_INFO": "Dahili bilgi",
    "SOURCES": "Kaynaklar",
    "CONVERSATION_SUMMARY": "Konuşma özeti",
    "WAITING": "Bekleniyor",
    "WIDGET_DISABLED": "Widget devre dışı bırakıldı",
    "AI_SETTINGS_DISABLED": "Yapay zeka ayarları devre dışı bırakıldı! Lütfen AI yöneticisi ile iletişime geçin",
    "SERVER_CONNECTION_ERROR": "Sunucuya bağlanırken hata oluştu",
    "VIEW": "Görüntüle",
    "ATTACHMENT_INPUT": "Ek girişi",
    "TYPE_SUMMARY": "Özet yazın",
    "BY":"Tarafından",
    GENERATE_SUMMARY: "Özet oluştur",
    PREV_SUMMARIES: "Önceden Oluşturulan Özetler",
    DIALOG_WORKFLOWS: "Diyalog İş Akışları",
    SHOW_ALL_DIALOG: "Tüm Diyalog Görevlerini Göster",
    SHOW_ALL_DIALOGS: "Tüm Diyalogları Göster",
    CUSTOM_TAB: "Özel Sekme",
    AGENT_INPUT: "Ajan Girişi",
    CUSTOM_EMPTY_MSG: "Şu anda aktif bir iş akışı yok",
    CUSTOM_TAB_DESC: "Bir iş akışı başlatmak için, ekranın altındaki listeden bir tane çalıştırın.",
    SUBMIT_OVERALL_FEEDBACK: "Genel Geri Bildirim Gönder",
    FEEDBACK_POPUP_SUBTITLE: "Widget ve özelliklerinize ilişkin geri bildiriminiz",
    FEEDBACK_SATISFIED: "Memnun",
    FEEDBACK_UNSATISFIED: "Memnun Değil",
    FEEDBACK_PROVIDE_REASONS: "Daha Fazla Bilgi Ver",
    FEEDBACK_TITLE: "Geri Bildirim",
    "AGENTIC_THINKING" : "Düşünüyor",
    "AGENTIC_AGENT_TITLE" : "Ajan",
    "AGENTIC_COPILOT_MODE_TITLE" : "Ajan Copilot Modu",
    "AGENTIC_SENDING_MESSAGE" : "Gönderiliyor...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot konuşmanızı aktif olarak dinliyor ve otomatik olarak yardımcı olmaya hazır",
    "AGENTIC_SEARCH_RESULTS" : "Ajan Sonuçları"
}
